import { Group } from "@mantine/core"
import { SuperAdminVenueBookingTabs } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingTabs"
import { EditSuperAdminVenueBookingAction } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { formatDate, formatTime } from "src/utils/dates"
import { SuperAdminVenueBookingView } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingView"

export function SuperAdminVenueBooking() {

    const { currentItem } = useAppState(state=>state.bookings)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.talent?.alias} ${formatDate(currentItem?.date)} ${!!currentItem?.set_start_time ? '@ ': ''}${formatTime(currentItem?.set_start_time)}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminVenueBookingAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminVenueBookingTabs/>
            <SuperAdminVenueBookingView/>
        </PageLayout>
    )

}